/*
 * Vremou sticky bestelbalk
 * ---------------------------------------------------------------
 * Verschijnt zodra de gewone bestelknop uit beeld is en verdwijnt
 * weer wanneer die terugkomt. Zonder waarnemer blijft de balk
 * gewoon zichtbaar, zodat bestellen altijd mogelijk is.
 */

class VremouSticky extends HTMLElement {
  connectedCallback() {
    this.watchSelector = this.dataset.watch;

    if (!this.watchSelector || !('IntersectionObserver' in window)) {
      this.setAttribute('data-visible', '');
      return;
    }

    const target = document.querySelector(this.watchSelector);

    if (!target) {
      this.setAttribute('data-visible', '');
      return;
    }

    // De onderrand krimpt met ongeveer de hoogte van de balk zelf. Daardoor
    // verschijnt de balk precies wanneer de gewone bestelknop eronder
    // wegschuift, en niet al terwijl die nog midden in beeld staat.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.toggleAttribute('data-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -76px 0px' }
    );

    observer.observe(target);
  }
}

if (!customElements.get('vremou-sticky')) {
  customElements.define('vremou-sticky', VremouSticky);
}
